module.exports = __webpack_public_path__ + "img/part3-bg6.1ae881ee.png";